module.exports = __webpack_public_path__ + "img/symbol-sqrt-center.314de7ac.png";